import { useState } from 'react'
import { useQuery } from 'react-query'
import { useProfile } from 'querys/profile'

const fetcher = async (url, token) => {
  const res = await fetch(url, {
    method: 'GET',
    headers: { Authorization: `token ${token}` },
  })
  const data = await res.json()
  if (res.status !== 200) {
    throw new Error(data)
  }
  return data
}

export function useFirstRepos() {
  const {
    data: {
      info: { github_username: username, github_token },
    },
  } = useProfile()
  return useQuery(
    ['ALL_REPOS', github_token],
    () => fetcher(`/api/github/all?username=${username}`, github_token),
    {
      // TO DO: refetch on windows focus only in prod
      enabled: !!username,
      refetchOnWindowFocus: false,
    },
  )
}

export function useSearchRepo() {
  const {
    data: {
      info: { github_username: username, github_token },
    },
  } = useProfile()
  const [value, setValue] = useState('')
  const [enabled, setEnabled] = useState(false)
  const query = useQuery(
    ['SEARCH_REPO', value],
    () => fetcher(`/api/github/search?q=${value}&username=${username}`, github_token),
    {
      enabled,
      refetchOnWindowFocus: true,
      keepPreviousData: true,
    },
  )
  return {
    ...query,
    value,
    setValue,
    setEnabled,
  }
}

export function useRepo(repo) {
  const {
    data: {
      info: { github_username: username, github_token },
    },
  } = useProfile()
  return useQuery(
    ['REPO', repo],
    () => fetcher(`/api/github/repo?repo=${repo}&username=${username}`, github_token),
    {
      refetchOnWindowFocus: true,
    },
  )
}
